<template>
<div class="product-item" @click="gotoProductDetail">
  <div class="product-bg" :style="{'background': `url(${product.website_bkg_img}) no-repeat center / 100% 100%`}"></div>
  <div class="product-info">
    <div class="product-name">{{product.product_name}}</div>
    <div class="product-bottom">
      <div class="product-price">
        <div class="sell-price">¥{{(product.special_price || product.peer_price)|setPrice}}</div>
        <div class="original-price" v-if="product.special_price">¥{{product.peer_price|setPrice}}</div>
      </div>
      <!-- <div class="product-price" v-else>
        <div class="sell-price">¥ -</div>
      </div> -->
      <div class="product-detail-btn" v-if="floorInfo.pc_per_row_number === 1">查看详情</div>
    </div>
  </div>
</div>
</template>

<script>
import User from '../../../../libs/user';
import sensorService from '../../../../services/sensor-service';

export default {
  name: '',
  components: {},
  props: {
    product: Object,
    activityFloorInfo: Object,
    floorInfo: Object,
    activityId: [String, Number],
  },
  data() {
    return {
      User,
    };
  },
  computed: {},
  watch: {},
  created() {},
  methods: {
    gotoProductDetail() {
      let from = '';
      if (User.isLogin() && this.activityFloorInfo.channel) {
        from = `activity_${this.activityFloorInfo.id}_${this.activityFloorInfo.title}_${this.activityFloorInfo.channel.channel_no}_${this.activityFloorInfo.channel.channel_name}`;
      }
      // 商详神策埋点page_from字段----获取当前路由的page_from
      const pageFrom = sensorService.getPageFrom(`活动页-${this.activityId || ''}`);
      this.$router.push({ name: 'productDetail', query: { visa_product_id: this.product.id, from, ...pageFrom } });
    },
  },
  filters: {
    setPrice(val) {
      return val / 100;
    },
  },
};
</script>

<style scoped lang="less">
.product-item{
  width: 100%;
  border-radius: 4px;
  background: #fff;
  overflow: hidden;
  cursor: pointer;
  .product-bg{
    width: 100%;
    height: 157px;
  }
  .product-info{
    padding: 22px 24px;
    .product-name{
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-box-orient: vertical;
      -webkit-line-clamp: 2;
      color: #333333;
      font-size: 20px;
      line-height: 32px;
      min-height: 64px;
    }
    .product-bottom{
      display: flex;
      justify-content: space-between;
    }
    .product-detail-btn{
      padding: 15px 33px;
      border-radius: 4px;
      color: #fff;
      font-size: 18px;
      cursor: pointer;
      background-color: #FF2139;
    }
    .product-price{
      margin-top: 16px;
      display: flex;
      align-items: center;
      .sell-price{
        color: #FF0082;
        font-size: 24px;
        font-weight: 600;
      }
      .original-price{
        color: #666666;
        font-size: 20px;
        margin-left: 15px;
        text-decoration: line-through;
      }
    }
  }


}
</style>



// WEBPACK FOOTER //
// src/pages/activity/daily-activity/components/product-item.vue